module.exports = __webpack_public_path__ + "static/media/clupp-logo.055aef08.png";